export class UsuarioIntegrador {
  id: number;
  idIntegrador: number;
  nome: string;
  email: string;
  verTodosPedidos: boolean;
  podeConfirmarPedido: boolean;
  podeSimular: boolean;
  ativo: boolean;
  url: string;
}
